import { useSignalR } from "../../../common/helpers/SignalR";
import { UpdatedApplicationNotification } from "../models/UpdatedApplicationNotification";

export const useUpdatedApplicationNotification = (callback: (notification: UpdatedApplicationNotification) => void) => useSignalR<UpdatedApplicationNotification>("UpdateApplication", callback);